import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import {
	ICmmsFilterComponent,
	ICmmsFilterEmittedValue,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/cmms-applied-filters-bar/interfaces/filter-component.interface';

import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	templateUrl: './binary-filter.component.html',
	styleUrls: ['./binary-filter.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgxTolgeeModule],
})
export class BinaryFilterComponent implements ICmmsFilterComponent, OnInit {
	@Input() data: { preselectedValue: boolean; columnName: string };
	@Output() filterValueChanged = new EventEmitter<ICmmsFilterEmittedValue>();

	ngOnInit(): void {
		if (this.data.preselectedValue !== undefined) {
			setTimeout(() => {
				this.selectStatus({
					key: this.data.preselectedValue ? 'yes' : 'no',
					value: this.data.preselectedValue,
				});
			});
		}
	}

	statuses: { key: string; value: boolean }[] = [
		{ key: 'yes', value: true },
		{ key: 'no', value: false },
	];

	selectedStatus: boolean;

	selectStatus(event: { key: string; value: boolean }) {
		this.selectedStatus = event.value;
		this.filterValueChanged.emit({
			columnName: this.data.columnName,
			label: event.key,
			data: event.value,
		});
	}
}
